import { LoginOption } from '../../data-types/login/loginInterfaces';
import { ResetState } from './stateTypes';

export type LoginActionType = ResetState | SetLoginOptions | SetIsLoggingInFromRedirect | SetFromAppFlag;

export const SET_LOGIN_OPTIONS = 'SET_LOGIN_OPTIONS';
export const SET_IS_LOGGING_IN_FROM_REDIRECT = 'SET_IS_LOGGING_IN_FROM_REDIRECT';
export const SET_FROM_APP_FLAG = 'SET_FROM_APP_FLAG';

export interface LoginState {
  loginOptions: LoginOption[];
  isLoggingInFromRedirect: boolean;
  isFromApp: boolean;
}

interface SetLoginOptions {
  type: typeof SET_LOGIN_OPTIONS;
  meta: LoginOption[];
}

interface SetIsLoggingInFromRedirect {
  type: typeof SET_IS_LOGGING_IN_FROM_REDIRECT;
  meta: boolean;
}

interface SetFromAppFlag {
  type: typeof SET_FROM_APP_FLAG;
  meta: boolean;
}
